module.exports = __webpack_public_path__ + "assets/img/81886c11c4b43545d4c158acee924464.svg";